import { surveyConstants } from '../constants';
import defaultImage from "assets/img/image_placeholder.jpg";
import lodash from 'lodash';

var initialState = {
    formOpen: false,
    formMode: 'add',
    formInitialValue: {},
    //numberAnswerSet: 1,
    tableKey: 0,
    tableData: {
        data: [],
        total: 0
    },
    tableSubSurveyData: {
        data: [],
        total: 0
    },
    tableReset: false,
    tableReload: false,
    surveyList: [],
    allProductList: [],
    productList: [],
    selectedProductList: [],
    formProductListLoader: false,
    tableLoader: false,
    formMemberLevellist: [],
    trdPartyCodeSet: [],
    shopListSelected:[],
    rewardImagePreview: defaultImage,
    surveyImagePreview: defaultImage,
    thankImagePreview: defaultImage,
    productListMaster:[]
}

export function survey(state = initialState, action) {
    switch (action.type) {

        case surveyConstants.CLEAR_PAGE_STATE:
            return initialState

        case surveyConstants.GET_SURVEY_DATA_SUCCESS: {
            //console.log("list");
            //console.log(action.data);
            return {
                ...state,
                tableData: action.data,
                tableReload: false,
                tableReset: false
            }
        }

        case surveyConstants.GET_SUB_SURVEY_DATA_SUCCESS: {
            //console.log("list");
            //console.log(action.data);
            return {
                ...state,
                tableSubSurveyData: action.data,
                tableReload: false,
                //tableReload: true,
                tableReset: false
            }
        }

        case surveyConstants.GET_COMPLETE_SURVEY_DATA_SUCCESS: {

            //console.log("list");
            //console.log(action.data);
            // return {
            //     ...state,
            //     tableData: action.data,
            //     tableReload: false,
            //     tableReset: false
            // }

            const { data, params } = action; // Destructure action to get data and params
            //console.log("params",params);
            return {
                ...state,
                tableData: data,
                paramsReport: params, // Update paramsReport with the passed params
                tableReload: false,
                tableReset: false
            };
        }

        case surveyConstants.SURVEY_LIST: {
            //console.log("SURVEY_LIST");
            //console.log(action.data);
            return {
                ...state,
                
                surveyList: action.data
            }
        }
        
        case surveyConstants.ADD_SURVEY: {
            return {
                ...state,
                formOpen: false,
                formInitialValue: {
                    ...state.formInitialValue,
                },
                tableReload: false,
                tableReset: true,
                tableKey: new Date(),
            }
        }

        case surveyConstants.ADD_SUB_SURVEY: {
            console.log("ADD_SUB_SURVEY");
            const { ...rest } = state.formInitialValue;
            return {
                ...state,
                formOpen: false,
                formInitialValue: {
                    ...rest,
                    ...action.data,
                    //...state.formInitialValue, 
                    // questionType: "", 
                    // question: "",
                    // numberAnswer: "",
                    // numberSelectAnswer: "",
                    // status_subsurvey: "",
                    // answer1: "",
                    // answer2: "",
                    // answer3: "",
                    // answer4: "",
                    // answer5: "",
                    // answer6: "",
                    // answer7: "",
                    // answer8: "",
                    // answer9: "",
                    // answer10: "",
                    // answer11: "",
                    // answer12: "",
                    // answer13: "",
                    // answer14: "",
                    // answer15: "",
                    // givePoint1: "",
                    // givePoint2: "",
                    // givePoint3: "",
                    // givePoint4: "",
                    // givePoint5: "",
                    // givePoint6: "",
                    // givePoint7: "",
                    // givePoint8: "",
                    // givePoint9: "",
                    // givePoint10: "",
                    // givePoint11: "",
                    // givePoint12: "",
                    // givePoint13: "",
                    // givePoint14: "",
                    // givePoint15: "",                   
                },
                tableReload: false,
                tableReset: true,
                tableKey: new Date(),
            }
        }

        case surveyConstants.OPEN_ADD_NEW_SURVEY:
            return {
                ...state,
                formOpen: true,
                formMode: 'add',
                //formInitialValue: action.data,
                surveyImagePreview: defaultImage,
                thankImagePreview: defaultImage,
            };

        case surveyConstants.OPEN_ADD_NEW_SUB_SURVEY:
            console.log("OPEN_ADD_NEW_SUB_SURVEY");
            const { _id, ...rest } = state.formInitialValue;
            return {
                ...state,
                formOpen: true,
                formMode: 'add',
                //formInitialValue: action.data,
                formInitialValue: {
                    ...rest,
                    ...action.data,
                    // questionType: "", 
                    // question: "",
                    // numberAnswer: "",
                    // numberSelectAnswer: "",
                    // status_subsurvey: "",
                    // answer1: "",
                    // answer2: "",
                    // answer3: "",
                    // answer4: "",
                    // answer5: "",
                    // answer6: "",
                    // answer7: "",
                    // answer8: "",
                    // answer9: "",
                    // answer10: "",
                    // answer11: "",
                    // answer12: "",
                    // answer13: "",
                    // answer14: "",
                    // answer15: "",
                    // givePoint1: "",
                    // givePoint2: "",
                    // givePoint3: "",
                    // givePoint4: "",
                    // givePoint5: "",
                    // givePoint6: "",
                    // givePoint7: "",
                    // givePoint8: "",
                    // givePoint9: "",
                    // givePoint10: "",
                    // givePoint11: "",
                    // givePoint12: "",
                    // givePoint13: "",
                    // givePoint14: "",
                    // givePoint15: "",

                },
                               
            };    

        case surveyConstants.OPEN_EDIT_SURVEY:

            return {
                ...state,
                formOpen: true,
                formMode: 'edit',
                formInitialValue: action.data,
                surveyImagePreview: action.surveyImagePreview,
                thankImagePreview: action.thankImagePreview,

        } 

        case surveyConstants.SET_FORM_PREVIEW_IMAGE:
         return {
            ...state,
            surveyImagePreview: action.surveyImagePreview === "default"? defaultImage : action.surveyImagePreview,
            //thankImagePreview: action.thankImagePreview === "default"? defaultImage : action.thankImagePreview
        }

        case surveyConstants.SET_FORM_PREVIEW_IMAGE_THANK:
         return {
            ...state,
            //surveyImagePreview: action.surveyImagePreview === "default"? defaultImage : action.surveyImagePreview,
            thankImagePreview: action.thankImagePreview === "default"? defaultImage : action.thankImagePreview
        }

        case surveyConstants.OPEN_EDIT_SUB_SURVEY:
            
            return {
                ...state,
                formOpen: true,
                formMode: 'edit',
                formInitialValue: {
                    ...state.formInitialValue,  // Retain existing initial values
                    ...action.data              // Override or add new values from action.data
                },
                           
        } 

        case surveyConstants.EDIT_SURVEY_SUCCESS: {
            return {
                ...state,
                formOpen: false,
                formInitialValue: {
                    ...state.formInitialValue,  // Retain existing initial values
                },
                tableReload: true,
                tableReset: false,
            }
        }

        case surveyConstants.EDIT_SUB_SURVEY_SUCCESS: {
            //console.log('SUB_SURVEY2 state.formInitialValue:', state.formInitialValue);
            return {
                ...state,
                formOpen: false,
                // formInitialValue: {},
                formInitialValue: {
                    ...state.formInitialValue,                   
                },
                tableReload: true,
                tableReset: false,
            }
        }

        case surveyConstants.CLOSE_FORM_SURVEY:
            
            return {
                ...state,
                formOpen: false,
                formInitialValue: {},
                tableSubSurveyData: {},
                //surveyId: "",
                
            }

        case surveyConstants.CLOSE_FORM_SUB_SURVEY:
            return {
                ...state,
                formOpen: false,
                //formInitialValue: {},
                formInitialValue: {
                    ...state.formInitialValue,                  
                },
                //numberAnswerSet: 0,
                
            }

        case surveyConstants.SHOW_TABLE_LOADER: {
            //console.log("SHOW_TABLE_LOADER");
            return {
                ...state,
                tableLoader: true
            }
        }
        case surveyConstants.HIDE_TABLE_LOADER: {
            //console.log("HIDE_TABLE_LOADER");
            return {
                ...state,
                tableLoader: false
            }
        }

        case surveyConstants.TABLE_RELOAD_SUCCESS: {
            return {
                ...state,
                tableReload: false,
                tableReset: false
            }
        }

        case surveyConstants.DELETE_SUB_SURVEY_SUCCESS: {
            console.log("DELETE_SUB_SURVEY_SUCCESS");
            return {
                ...state,
                //tableReload: true,
                tableReset: true,
                //tableKey: new Date(),
            }
        }
        
        default:
            return state;
    }
}
